// globals
import "moment/locale/es-mx";
// JS de Bootstrap para el collapse del navbar (data-bs-toggle="collapse")
import "bootstrap/js/dist/collapse";

// @dblimp/core — evolución de dbl-components, reescrito en TypeScript.
// Patrón: `addComponents(...)` registra componentes en el registry global de
// JsonRender y `appCtrl.init()` inicializa definiciones, controllers, rutas.
import { addComponents, appCtrl, Controller } from "@dblimp/core";
import type { Component as DblimpComponent } from "@dblimp/core";

// @dblimp/bs5 — capa Bootstrap 5 (navegación, contenedores, campos, tablas)
import { Action, BrandNavigation, CardListNavigation, CardsNavigation, HeaderNavigation, MenuItem, Navbar, Navigation, SideNavigation, Table, containers as bs5Containers, fields as bs5Fields } from "@dblimp/bs5";

// @dblimp/icomoon — set de iconos (define el componente `Icons` y `setIconSet`)
import Icons, { setIconSet } from "@dblimp/icomoon";

// Rutas JSON
import rootSchema from "./schemas/root-schema.json";
import homeRoute from "./schemas/routes/home.json";
import productosRoute from "./schemas/routes/productos.json";
import productoRoute from "./schemas/routes/producto.json";
import recetasRoute from "./schemas/routes/recetas.json";
import carritoRoute from "./schemas/routes/carrito.json";
import recetaRoute from "./schemas/routes/receta.json";
import quienesSomosRoute from "./schemas/routes/quienes-somos.json";
import contactoRoute from "./schemas/routes/contacto.json";
import notFoundRoute from "./schemas/routes/404-routes.json";

// Definitions (metadatos de navegación, etc.)
import navigationDefinitions from "./schemas/definitions/navigation-schema.json";

// Set de íconos propio de MANGIBONE (cargado antes de addComponents)
import mbIcons from "./icon-font/selection.json";
setIconSet(mbIcons as any);

// Controllers
import RootController from "./controllers/root-controller";

// Componentes propios del proyecto
import ProductCard from "./components/product-card/product-card";
import RecipeCard from "./components/recipe-card/recipe-card";
import SiteFooter from "./components/site-footer/site-footer";
import SiteHeader from "./components/site-header/site-header";

// Páginas
import ContactoPage from "./pages/contacto-page/contacto-page";
import HomePage from "./pages/home-page/home-page";
import NotFoundPage from "./pages/not-found-page/not-found-page";
import ProductosPage from "./pages/productos-page/productos-page";
import ProductoPage from "./pages/producto-page/producto-page";
import QuienesSomosPage from "./pages/quienes-somos-page/quienes-somos-page";
import RecetaPage from "./pages/receta-page/receta-page";
import RecetasPage from "./pages/recetas-page/recetas-page";
import CarritoPage from "./pages/carrito-page/carrito-page";

/**
 * Registro explícito de componentes con `addComponents(...)`.
 * Esto es lo que permite que los schemas JSON usen `{"component": "X"}`.
 */
addComponents({
  // Núcleo
  Controller,
  Icons,
  // @dblimp/bs5
  Action,
  BrandNavigation,
  CardListNavigation,
  CardsNavigation,
  HeaderNavigation,
  MenuItem,
  Navbar,
  Navigation,
  SideNavigation,
  Table,
  ...bs5Containers,
  ...bs5Fields,
  // Layout
  SiteHeader,
  SiteFooter,
  // Widgets
  ProductCard,
  RecipeCard,
  // Páginas
  HomePage,
  ProductosPage,
  ProductoPage,
  RecetasPage,
  CarritoPage,
  RecetaPage,
  QuienesSomosPage,
  ContactoPage,
  NotFoundPage,
} as Record<string, typeof DblimpComponent | any>);

// Inicializar appCtrl — patrón angular-like con addComponents
appCtrl.init({
  fields: {},
  components: {},
  controllers: {
    RootController,
  },
  definitions: [navigationDefinitions],
  schema: rootSchema,
  routes: [
    homeRoute,
    productosRoute,
    productoRoute,
    recetasRoute,
    carritoRoute,
    recetaRoute,
    quienesSomosRoute,
    contactoRoute,
    notFoundRoute,
  ],
  initialState: {},
  api:
    import.meta.env.VITE_API_URL === "/"
      ? window.location.origin
      : import.meta.env.VITE_API_URL,
  apiHeaders: import.meta.env.VITE_API_HEADERS,
  lang: "es-MX",
  formatDate: {
    "es-MX": {
      default: "DD/MM/YYYY",
      longDate: "DD [de] MMMM [de] YYYY",
    },
  },
  formatTime: {
    hourPicker: "hh:mm A",
    "es-MX": "hh:mm A",
  },
  formatDateTime: {
    "es-MX": "DD/MM/YYYY hh:mm A",
  },
  dictionary: {
    "es-MX": {
      " to ": " a ",
      " from ": " de ",
      Search: "Buscar",
      "Registros / página": "Registros / página",
      "Search by...": "Buscar por...",
    },
    default: {
      " to ": " to ",
      " from ": " from ",
    },
  },
  fetchBefore: (url: string, options: Record<string, any>) => options,
  fetchAfter: (res: any) => res,
});

export default appCtrl;
